<template>
    <div class="today-alarm" >
        <div class="toptitle dn-title-bg">不平衡度</div>
        <div class="topcontent dn-content-bg table-warp" v-loading="ifLoad">
            <el-table
                :data="tableData"
                height="188"
                class="dn-content-bg"
                style="border-radius: 4px"
                :stripe="true"
                :cell-style="tableCellStyle"
            >
            <!--  -->
                <template v-for="(item,index) in columns" >
                    <el-table-column :key="index" :prop="item.prop" :label="item.label"  :align="item.align?item.align:'center'" :show-overflow-tooltip="item.showTool?item.showTool:false"></el-table-column>
                </template>
            </el-table>
        </div>
    </div>
</template>
<script>
let vm;
export default {
    props:{
        tableData:
        {
            type: Array ,
            default: () => []
        },
        ifLoad:{
            type:Boolean,
            default:false,
        }
    },
    data() {
        return {
            loading: false,
            columns:[
                { prop: "dataType", label: "数据类型", show:true, align: "left",showTool:true },
                { prop: "realTimePercent", label: "实时值", show:true, align: "left",showTool:true },
                { prop: "maximum", label: "历史最大值", show:true, align: "left",showTool:true },
                { prop: "maximumTime", label: "最大值发生时间", show:true, align: "left",showTool:true },
                { prop: "standardValue", label: "数据标准值", show:true, align: "left" },
                { prop: "assess", label: "评价", show:true, align: "left"},
            ]
        };
    },
    created() {
    },
    methods: {
        //设置单元格样式
        tableCellStyle (row,column, rowIndex, columnIndex) {
            if (row.columnIndex === 5 && row.row.assess === '不合格') {
                return 'color:#EF4242'
            }else if(row.columnIndex === 5 && row.row.assess === '合格'){
                return 'color:#52CCA3'
            }
        },
        tableHeaderColor({ row, column, rowIndex, columnIndex }) {
            //改表头颜色
            if (rowIndex === 0) {
                return "background-color: rgba(209, 236, 249);color: #666;";
            }
        },
        tableRowClassNameOne({ row, rowIndex }) {
            if (rowIndex === 0) {
                return "success-row";
            } else if (rowIndex === 1) {
                return "warning-row";
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.toptitle {
  color: #fff;
  font-weight: bold;
  display: flex;
  padding: 5px;
  font-size: 16px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.topcontent {
  height: 200px;
  padding: 5px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

</style>
